import { createStyles } from './utils';

export const styles = createStyles({
    header: {
        paddingInline: '0px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100vw',
        background: 'white',
    },
    flexDisplay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    navLinks: {
        display: 'flex',
        justifyContent: 'start',
        color: '#fff', 
        fontSize:'16px',
        marginLeft: '30px'
    },
    blogContainer: {
        margin:'10px',
        marginTop: '20px',
        background: 'rgb(34 34 34)',
        borderTop: '10px solid #064a45',
        // borderBottom: '10px solid rgb(23 10 10)',
        borderRight: '10px solid #064a45',
        borderRadius: '10px'
    },
    mainHeading: {
        color: '#fff', 
        fontFamily: 'cursive', 
        fontSize: '1.75rem',
        textAlign: 'start'
    },
    blogHeading: {
        color: '#fff',
        fontFamily: 'cursive',
        fontWeight: '400',
        fontSize: '1.5rem',
        textAlign: 'start'
    },
    blogParagraph: {
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
        fontSize: '20px',
        textAlign: 'start',
    },
    logo:{
        display:'flex',
        justifyContent: 'center', 
        padding:'20px'
    },
    card: {
        paddingBottom:'20px',
        height: '95%',
    },
    paragraph: {
        paddingTop:'10px'
    },
    gridStyle: {
        width: '25%',
        textAlign: 'center',
    },
    homeButton: {
        marginLeft: '5px',
        marginRight: '5px',
        background:'rgb(52, 207, 171)',
        color: 'white',
        height: '40px',
        borderRadius: '5px',
    },
    imgWidth: {
        width: '50px',
    },
    category: {
        display: 'flex', 
        alignItems: 'center', 
        color: '#c9c2c2', 
        fontSize: '18px', 
        textTransform: 'capitalize', 
        margin: '10px'
    }
});